import type { Entry } from './types';
import { useLocaleStore } from './locale';
import { nav } from './catalog/nav';

/**
 * Translate a manifest nav/breadcrumb label. Labels are the manifests' English
 * strings; unknown labels pass through unchanged (safe for feature growth).
 */
export function useNavLabel() {
  const locale = useLocaleStore((s) => s.locale);
  return (label: string): string => {
    const entry = (nav as Record<string, Entry>)[label];
    return entry ? entry[locale] : label;
  };
}
